import { Link } from 'react-router-dom';
import { track } from '@/lib/analytics';
import { useTenant } from '@/modules/tenant/presentation/hooks/use-tenant';
import type { GabaritoSubmissionState } from '@/modules/tenant/domain/entities/tenant.entity';

/**
 * O recado de cada estado, para as telas que explicam por que não há botão
 * (as abas vazias do painel, a própria `/gabarito`).
 */
export const GABARITO_SUBMISSION_NOTE: Record<
  Exclude<GabaritoSubmissionState, 'open'>,
  string
> = {
  soon: 'O envio do gabarito abre depois da prova.',
  closed: 'O envio do gabarito desta prova foi encerrado.',
};

/** O estado do envio do gabarito na edição deste build. */
export function useGabaritoSubmission(): GabaritoSubmissionState {
  return useTenant().edition.gabaritoSubmission;
}

/**
 * **Todo convite para enviar o gabarito passa por aqui** — o botão da home e
 * os do painel —, para que o estado da edição (`gabaritoSubmission`, no
 * `EXAM_EDITIONS`) valha igual em todos os lugares:
 *
 * - `open`: o link para `/gabarito`;
 * - `soon`: o mesmo lugar, desabilitado, dizendo que vem depois da prova —
 *   quem chega antes já sabe que o envio existe;
 * - `closed`: nada.
 */
export function SendGabaritoAction({
  variant,
  local,
  label = 'Enviar meu gabarito',
}: {
  /** `cta` e `ghost` são os botões do sistema; `link`, o texto corrido. */
  variant: 'cta' | 'ghost' | 'link';
  /** Onde o botão está, para o evento `cta_clicado`. */
  local: 'hero' | 'fechamento' | 'painel';
  label?: string;
}) {
  const state = useGabaritoSubmission();
  if (state === 'closed') return null;

  const className =
    variant === 'cta'
      ? 'cta cta-inline'
      : variant === 'ghost'
        ? 'ghost ghost-lg'
        : undefined;

  if (state === 'soon') {
    if (variant === 'link') return null;
    return (
      <button type="button" className={className} disabled>
        Envio do gabarito em breve
      </button>
    );
  }

  return (
    <Link
      className={className}
      to="/gabarito"
      onClick={() =>
        track({ event: 'cta_clicado', cta: 'enviar_gabarito', local })
      }
    >
      {label}
    </Link>
  );
}
